import { apiCall, filterParams } from '../helpers/axios';

class PendingBidService {

	static getItemPendingBids(itemId, params) {
		return apiCall().get(`/items/${itemId}/pending_bids`, { params: params })
			.then(response => response.data);
	}

	static getAuctionPendingBids(auctionId, params) {
		return apiCall().get(`/auctions/${auctionId}/pending_bids`, { params: params })
			.then(response => response.data);
	}
}

export default PendingBidService



// WEBPACK FOOTER //
// ./src/services/pending-bid-service.js